import db from '../db.js';

const model = {
  getSourceConfig(param) {
    console.log('params', param);
    console.log('db', db);
    // 正式的
    return db.get('/dispatch-page/info', param);
  },
  getCode(param) {
    // 真实的一个
    return db.get('/dispatch-page/getCode', param);
    // 模拟一个
    // console.log("storeRegion:", param);
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({ data: Math.floor(Math.random() * 9999) + param.region });
    //   }, 100);
    // });
  },
  getLocation() {
    return db.get('/dispatch-page/getLocation');
  },
};
export default model;
